<template>
  <div
    class="hover-reveal"
    ref="refRoot"
    :hovering="isHovering ? true : null"
  >
    <div class="base">
      <slot />
    </div>
    <div
      class="reveal"
      :aria-hidden="true"
    >
      <div class="reveal-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  hovering: {},
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()
const { app, debug, browser } = useStores()

// *********************************************
// HOVERING
// *********************************************
const refRoot = ref(null)
const _hovering = useElementHover(refRoot)
const isHovering = computed(() => {
  if (props.hovering != undefined) return props.hovering
  return _hovering.value
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.hover-reveal {
  position: relative;
}

.reveal {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.6s ease 0s;

  mask-image: linear-gradient(to right, #fff 33.333333%, #0000 66.666666%);
  mask-size: 300% 100%;
  mask-position: 100% 0%;
}

.hover-reveal[hovering] .reveal {
  mask-position: 0% 0%;
}
</style>
